var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 5.21875,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "matrix(-1 0 0 1 14.4062 8)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "matrix(-1 0 0 1 14.4062 6.4375)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "matrix(-1 0 0 1 14.4062 9.6875)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "matrix(-1 0 0 1 14.4062 11.3125)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "matrix(0 1 1 0 12.4688 12.4375)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65625,
    y: 8,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65625,
    y: 6.4375,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 6.90625,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 7.71875,
    y: 5.25,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 3.68326,
    y: 4.80859,
    width: 0.53125,
    height: 3.4375,
    rx: 0.265625,
    transform: "rotate(-117.561 3.68326 4.80859)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 0.53125,
    height: 3.4375,
    rx: 0.265625,
    transform: "matrix(0.462688 -0.886521 -0.886521 -0.462688 12.2662 4.74609)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65625,
    y: 9.6875,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65625,
    y: 11.3125,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3.59375,
    y: 12.4375,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "rotate(90 3.59375 12.4375)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3.59375,
    y: 12.4375,
    width: 0.53125,
    height: 1.09375,
    rx: 0.265625,
    transform: "rotate(90 3.59375 12.4375)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.125H3.875V6.625H0V1.125ZM0.84375 2.0625C0.84375 1.90717 0.96967 1.78125 1.125 1.78125H2.78125C2.93658 1.78125 3.0625 1.90717 3.0625 2.0625C3.0625 2.21783 2.93658 2.34375 2.78125 2.34375H1.125C0.96967 2.34375 0.84375 2.21783 0.84375 2.0625ZM1.125 2.875C0.96967 2.875 0.84375 3.00092 0.84375 3.15625C0.84375 3.31158 0.96967 3.4375 1.125 3.4375H2.78125C2.93658 3.4375 3.0625 3.31158 3.0625 3.15625C3.0625 3.00092 2.93658 2.875 2.78125 2.875H1.125ZM0.84375 4.3125C0.84375 4.15717 0.96967 4.03125 1.125 4.03125H2.78125C2.93658 4.03125 3.0625 4.15717 3.0625 4.3125C3.0625 4.46783 2.93658 4.59375 2.78125 4.59375H1.125C0.96967 4.59375 0.84375 4.46783 0.84375 4.3125ZM1.125 5.21875C0.96967 5.21875 0.84375 5.34467 0.84375 5.5C0.84375 5.65533 0.96967 5.78125 1.125 5.78125H2.78125C2.93658 5.78125 3.0625 5.65533 3.0625 5.5C3.0625 5.34467 2.93658 5.21875 2.78125 5.21875H1.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90625 0H6.03125V5.5H9.90625V0ZM6.875 0.9375C6.875 0.78217 7.00092 0.65625 7.15625 0.65625H8.8125C8.96783 0.65625 9.09375 0.78217 9.09375 0.9375C9.09375 1.09283 8.96783 1.21875 8.8125 1.21875H7.15625C7.00092 1.21875 6.875 1.09283 6.875 0.9375ZM6.875 2.03125C6.875 1.87592 7.00092 1.75 7.15625 1.75H8.8125C8.96783 1.75 9.09375 1.87592 9.09375 2.03125C9.09375 2.18658 8.96783 2.3125 8.8125 2.3125H7.15625C7.00092 2.3125 6.875 2.18658 6.875 2.03125ZM7.15625 2.90625C7.00092 2.90625 6.875 3.03217 6.875 3.1875C6.875 3.34283 7.00092 3.46875 7.15625 3.46875H8.8125C8.96783 3.46875 9.09375 3.34283 9.09375 3.1875C9.09375 3.03217 8.96783 2.90625 8.8125 2.90625H7.15625ZM6.875 4.375C6.875 4.21967 7.00092 4.09375 7.15625 4.09375H8.8125C8.96783 4.09375 9.09375 4.21967 9.09375 4.375C9.09375 4.53033 8.96783 4.65625 8.8125 4.65625H7.15625C7.00092 4.65625 6.875 4.53033 6.875 4.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.09375H12.125V6.59375H16V1.09375ZM12.9688 2.03125C12.9688 1.87592 13.0947 1.75 13.25 1.75H14.9062C15.0616 1.75 15.1875 1.87592 15.1875 2.03125C15.1875 2.18658 15.0616 2.3125 14.9062 2.3125H13.25C13.0947 2.3125 12.9688 2.18658 12.9688 2.03125ZM12.9688 3.125C12.9688 2.96967 13.0947 2.84375 13.25 2.84375H14.9062C15.0616 2.84375 15.1875 2.96967 15.1875 3.125C15.1875 3.28033 15.0616 3.40625 14.9062 3.40625H13.25C13.0947 3.40625 12.9688 3.28033 12.9688 3.125ZM13.25 4C13.0947 4 12.9688 4.12592 12.9688 4.28125C12.9688 4.43658 13.0947 4.5625 13.25 4.5625H14.9062C15.0616 4.5625 15.1875 4.43658 15.1875 4.28125C15.1875 4.12592 15.0616 4 14.9062 4H13.25ZM12.9688 5.46875C12.9688 5.31342 13.0947 5.1875 13.25 5.1875H14.9062C15.0616 5.1875 15.1875 5.31342 15.1875 5.46875C15.1875 5.62408 15.0616 5.75 14.9062 5.75H13.25C13.0947 5.75 12.9688 5.62408 12.9688 5.46875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15625 8.92306L3.78125 7.98556C3.8125 7.8866 3.98125 7.69806 4.40625 7.73556H6.34375C6.45312 7.6991 6.71563 7.69806 6.89062 7.98556L7.34375 8.57931C7.34896 8.66785 7.48438 8.84181 7.98438 8.82931H12C12.1667 8.85015 12.4969 9.01056 12.4844 9.48556V15.2668C12.4688 15.4335 12.35 15.8012 12 15.9387H3.89062C3.64583 15.9335 3.15625 15.8168 3.15625 15.3918V8.92306ZM4.21875 10.2969C4.21875 9.99484 4.46359 9.75 4.76562 9.75H9.67188C9.97391 9.75 10.2188 9.99484 10.2188 10.2969C10.2188 10.5989 9.97391 10.8438 9.67188 10.8438H4.76562C4.46359 10.8438 4.21875 10.5989 4.21875 10.2969ZM4.21875 12.5469C4.21875 12.3829 4.35167 12.25 4.51562 12.25H8.32813C8.49208 12.25 8.625 12.3829 8.625 12.5469C8.625 12.7108 8.49208 12.8438 8.32813 12.8438H4.51563C4.35167 12.8438 4.21875 12.7108 4.21875 12.5469ZM4.51562 14.4375C4.35167 14.4375 4.21875 14.5704 4.21875 14.7344C4.21875 14.8983 4.35167 15.0313 4.51563 15.0313H11.3594C11.5233 15.0313 11.6562 14.8983 11.6562 14.7344C11.6562 14.5704 11.5233 14.4375 11.3594 14.4375H4.51562ZM4.21875 13.5781C4.21875 13.4142 4.35167 13.2813 4.51562 13.2813H6.42188C6.58583 13.2813 6.71875 13.4142 6.71875 13.5781C6.71875 13.7421 6.58583 13.875 6.42188 13.875H4.51562C4.35167 13.875 4.21875 13.7421 4.21875 13.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortWhite);
export default __webpack_public_path__ + "static/media/sort-white.ba0b544130c8d2710cb19bf94c05caa5.svg";
export { ForwardRef as ReactComponent };